import React from "react";
import stylesLess from "./index.module.less";
import { AppContext } from "contexts/app";

export default function FormItem({ title, errMsg, children, style }) {
  const [appState, appDispatch] = React.useContext(AppContext);

  return (
    <div
      className={`${stylesLess.main} ${appState.isDark ? "dark" : "light"}`}
      style={style}
    >
      {title && <div className="iTitle">{title}</div>}
      {children && <div className="iBody">{children}</div>}
      {/*{errMsg && <div className="iErrMsg">{errMsg}</div>}*/}
      <div className="iErrMsg">{errMsg || ""}</div>
    </div>
  );
}
